import { FormattedMessage } from 'react-intl';

import ActiveDtcTag from '@/features/engineoil/card/customer/ActiveDtcTag';
import { STATUS } from '@/features/engineoil/utils/constants';
import {
    getIconColor,
    getIconName,
    getThresholdClass,
    isVehicleModelOlderThan2022,
} from '@/features/engineoil/utils/utils';
import type { EngineOil } from '@/generated/GeneratedApiTypes';
import BasePanel from './BasePanel';

// Ocu3SsSingle = TGE vehicle (OCU3 device, sensor-signal-single reading, ServiceCare S).
// State is always unknown; only status (danger/warning/normal) is resolved from percentage.
const Ocu3SsSingleSCSCard = ({ engineOil }: { engineOil: EngineOil }) => {
    const { status, measured_at, model_year, active_dtc } = engineOil;

    const hasActiveDtc = active_dtc != null;
    const iconName = getIconName(status);
    const iconClass = `uikit-icon ${iconName} ${getIconColor(status)} text-size-14 margin-right-5`;
    const showCallout = status !== STATUS.NORMAL && status !== STATUS.UNKNOWN;
    const calloutVariant = showCallout ? getThresholdClass(status) : '';

    return (
        <BasePanel
            timestamp={measured_at.date}
            mileage={measured_at.mileage_km}
            modelYear={model_year}
            testId="card-customer-ocu3-sensor_signal_single-service_care_s"
        >
            {!isVehicleModelOlderThan2022(model_year) ? (
                <>
                    <div className="space-y-10">{hasActiveDtc && <ActiveDtcTag dtcType={active_dtc!.type} />}</div>

                    <div
                        className={`display-flex align-items-center ${
                            calloutVariant ? `callout callout-${calloutVariant}` : ''
                        } padding-10 margin-top-10 margin-bottom-10`}
                    >
                        <div
                            className={`display-flex align-items-center ${
                                status === STATUS.NORMAL ? 'padding-left-10' : ''
                            }`}
                        >
                            {iconName && <span className={iconClass} />}
                            <span className="text-size-14 text-color-darkest">
                                <FormattedMessage id={`intl-msg:engineOil.state.criticality.${status}`} />
                            </span>
                        </div>
                    </div>
                </>
            ) : (
                <div className="text-size-14 text-color-darkest margin-top-10 margin-bottom-10">
                    <span className="uikit-icon icon-dangerousgoods margin-right-5" />
                    <FormattedMessage id="intl-msg:engineOil.card.ssSingle.banner.tge.notSupported" />
                </div>
            )}
        </BasePanel>
    );
};

export default Ocu3SsSingleSCSCard;
